import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import ListItem from "../ListItem/ListItem";
import "../../../../Utils/Css/Menu.css";

import Icon from "./Icon";

import BidTick from "./Bid";
import AskTick from "./Ask";

import AskQtyTick from "./AskQty";
import BidQtyTick from "./BidQty";

import ChnageTick from "./Chnage";
import LTPTick from "./Ltp";

import HighTick from "./High";
import LowTick from "./Low";
import OpenTick from "./Open";
import CloseTick from "./Close";

import TimeTick from "./Time";
import Mousetrap from "mousetrap";

export default function WatchlistCard(props) {
  const { id, index, type, item, updateId, reload, buy, sell } = props;

  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleEnter = () => {
      if (id === index) {
        setShow((prev) => !prev);
        updateId(index);
      }
    };
    Mousetrap.bind("enter", handleEnter);
    return () => {
      Mousetrap.unbind("enter", handleEnter);
    };
  }, [id, index, updateId]);

  useEffect(() => {
    if (id === index) {
      window.symbolData = item;
    }
  }, [id, index, item]);

  return (
    <li
      onClick={() => updateId(index)}
      onDoubleClick={() => setShow((prev) => !prev)}
      key={item.id}
      className={`menuContainer addHightMedium text ${
        id === index ? "selection" : ""
      }`}
    >
      <div className="menuIcon">
        <Icon symbol_id={item.symbol_id} />
      </div>

      <div className="menuExchange small">
          {item.type === "nse"
          ? "NSE-FUTURE"
          : item.type === "mcx"
          ? "MCX"
          : item.type === "mcx_options"
          ? "MCX-OPTIONS"
          : item.type === "fo"
          ? "NSE-OPTIONS"
          : item.type === "nse_cash"
          ? "NSE-EQUITY"
          : item.type === "comex_future"
          ? "COMEX"
          : item.type === "crypto_future"
          ? "CRYPTO"
          : item.type === "forex_future"
          ? "FOREX"
          : item.type === "us_stock"
          ? "US-STOCK"
          : item.type === "sgx"
          ? "SGX"
          : item.type === "index"
          ? "OTHERS"
          : item.type === "dgcx"
          ? "DGCX"
          : item.type === "ncdex"
          ? "NCDEX"
          : "-"}
      </div>
      <div className="menuSymbol addFlex">{item.symbol_display}</div>
      <div className="menuExpiry">
        {item.type === "nse_cash"
          ? "EQUITY"
          : moment(item.expiry_date).format("DD-MMM")}
      </div>
      <BidTick symbol_id={item.symbol_id} />
      {/* <BidQtyTick symbol_id={item.symbol_id} /> */}
      <AskTick symbol_id={item.symbol_id} />
      {/* <AskQtyTick symbol_id={item.symbol_id} /> */}
      <LTPTick symbol_id={item.symbol_id} />
      <ChnageTick type={item.type} symbol_id={item.symbol_id} />
      <OpenTick symbol_id={item.symbol_id} />
      <HighTick symbol_id={item.symbol_id} />
      <LowTick symbol_id={item.symbol_id} />
      <CloseTick symbol_id={item.symbol_id} />
      <TimeTick symbol_id={item.symbol_id} />
      {show && id === index && (
        <ListItem
          index={index}
          item={item}
          reload={reload}
          type={type}
          buy={buy}
          sell={sell}
          close={() => setShow(false)}
        />
      )}
    </li>
  );
}
